import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!

  return (_openBlock(), _createBlock(_component_DxNumberBox, {
    value: _ctx.modelValue,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue) = $event)),
    showSpinButtons: true,
    "show-clear-button": _ctx.hasEmptyValue,
    min: _ctx.min,
    max: _ctx.max,
    disabled: _ctx.disabled,
    readOnly: _ctx.readOnly,
    placeholder: _ctx.placeholder,
    step: _ctx.step,
    isValid: _ctx.isValid,
    format: _ctx.formatStr,
    visible: _ctx.visible,
    hint: _ctx.hint,
    onValueChanged: _ctx.valueChanged,
    onOnContentReady: _ctx.contentReady,
    onOnEnterKey: _ctx.enterKey
  }, null, 8, ["value", "show-clear-button", "min", "max", "disabled", "readOnly", "placeholder", "step", "isValid", "format", "visible", "hint", "onValueChanged", "onOnContentReady", "onOnEnterKey"]))
}